import { useMemo } from 'react';

import { getNextQuestionIndex } from '../lib/utils';

interface GameState {
    currentQuestionIndex: number;
    currentQuestion: Question | null;
    currentAnswer: ParticipationAnswer | null;
    allAnswersValid: boolean;
}

export default function useGameState(game: Game, participation: Participation, opts = {}) {
    const { questions = null } = game || {};

    const { answers: userAnswers = [] } = participation || {};

    const currentQuestionIndex = useMemo(
        () => getNextQuestionIndex(questions, userAnswers),
        [userAnswers, questions],
    );

    const currentQuestion = questions !== null ? questions[currentQuestionIndex] || null : null;
    const { id: questionId } = currentQuestion || {};
    const currentAnswer =
        (userAnswers || []).find(({ question }) => question === questionId) || null;

    const allAnswersValid =
        userAnswers.reduce<boolean | null>(
            (all, { valid = false }) => valid && (all === null || all === true),
            null,
        ) ?? false;

    return {
        currentQuestionIndex,
        currentQuestion,
        currentAnswer,
        allAnswersValid,
    };
}
